import { render } from "./ClinicalAreaPage.vue?vue&type=template&id=23d2dfdd"
import script from "./ClinicalAreaPage.vue?vue&type=script&lang=js"
export * from "./ClinicalAreaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__